
import BuildContext from 'rlink-router/BuildContext';
import getHttpRepo from 'rlink-repos/getHttpRepo';
import loadChecksumsForLocale from 'rlink-router/loadChecksumsForLocale';

export default class RuntimeBuildContext extends BuildContext {
  constructor ({appName, entryName, debug, useLongCaches, useLiveSafetyFeatures, defaultLocale,defaultRegion, loadViewFn, loadMessagesForLocale, appRouteDefinitions, reduxStore, appContentLoader, regions, locales, appContentRegistry, contentRoot, gdprCookieVersion}) {
    super();
    this.appName = appName;
    this.entryName = entryName;
    this.gdprCookieVersion = gdprCookieVersion;
    this.debug = !!debug;
    this.useLongCaches = !!useLongCaches;
    this.useLiveSafetyFeatures = !!useLiveSafetyFeatures;
    this.defaultLocale = defaultLocale;
    this.defaultRegion = defaultRegion;
    this.routeDefinitions = appRouteDefinitions;
    this.regions = regions;
    this.locales = locales;
    this.reduxStore = reduxStore;
    this.appContentLoader = appContentLoader;
    this.contentRegistry = appContentRegistry;
    this.loadViewFn = loadViewFn;
    this.loadMessagesForLocale = loadMessagesForLocale;
    this.contentRoot = contentRoot;
  }

  get isPrerender () {
    return false;
  }

  contentForView (contentMetaIndex, view, params = {}) {
    let {locale = this.defaultLocale} = params;
    return this.appContentLoader(view, params,
      getHttpRepo(
        this.contentRoot, contentMetaIndex, locale, this.contentRegistry, this.useLongCaches));
  }

  ensureContentMetaIndexFor (existingIndex = {}, _view, {locale = this.defaultLocale} = {}) {
    let {untranslated, translated = {}} = existingIndex;
    if (untranslated && translated[locale]) {
      return Promise.resolve(existingIndex);
    } else {
      let promiseOfUntranslatedChecksums = Promise.resolve(untranslated ? untranslated : loadChecksumsForLocale());
      return Promise.all([
        promiseOfUntranslatedChecksums,
        translated[locale] ? translated : (
          promiseOfUntranslatedChecksums
          .then(untranslatedChecksums => loadChecksumsForLocale(locale, untranslatedChecksums, this.useLongCaches, this.contentRoot))
          .then(localeChecksums => Object.assign({}, translated,
            {[locale]: localeChecksums}))
        ),
      ]).then(([newUntranslated, newTranslated]) => ({
        untranslated: newUntranslated,
        translated: newTranslated,
      }));
    }
  }

  async loadMessages (_view, {locale}) {
    return Object.assign({}, ...(await this.loadMessagesForLocale(locale || this.defaultLocale)));
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-router/RuntimeBuildContext.js